<template>
  <div class="privacy-policy">
    <div class="title">
      <h1>{{title}}</h1>
    </div>
    <div class="support-main clearfix">
      <div class="sidebar-column fl">
        <ul>
          <li :class="index==activeItem?'current':''" @click="clickSidebar(index)" v-for="(item,index) in siderList" :key="index">
            <span>{{item.name}}</span>
          </li>
        </ul>
      </div>
      <div class="content-column fr">
        <div class="article-typography">
          <div class="content" v-if="activeItem==0">
            <p>会员点击页面右上角“个人中心”输入注册会员手机号和密码登录后，可根据订单编号和订单状态查询您的订单。</p>
          </div>
          <div class="content" v-if="activeItem==1">
            <h3>支付宝</h3>
            <p>订购时您也可以选择第三方支付账户来支付您的订单，具体支付方式有“支付宝”支付。</p>
            <h3>微信支付</h3>
            <p>订购时您也可以选择第三方支付账户来支付您的订单，具体支付方式有“微信支付”。</p>
            <h3>花呗分期支付</h3>
            <p>订购时您也可以选择第三方支付账户来支付您的订单，具体支付方式有“花呗分期”。</p>
          </div>
          <div class="content" v-if="activeItem==2">
            <p>鬼塚虎官方商城目前开通的快递包括：顺丰快递。</p>
            <p>请选择按照您的送货地址选择正确的省、市、区/县，并按照页面提示输入完整地址后，系统会根据您输入的送货地址选择快递公司  ，在鬼塚虎官方商城任意消费均可享受中国大陆地区（不包括中国香港、中国澳门及中国台湾地区）免费配送服务  。</p>
            <p>我们将于您下单后【3 - 5】日内 安排快递。实际运送时间请以各快递具体运送时间为准。</p>
          </div>
          <div class="content" v-if="activeItem==3">
            <h3>7天无理由退货</h3>
            <p>
              <span></span>
            </p>
            <p>Onitsuka Tiger官方线上商城所售商品支持7天无理由退货（非质量问题的定制款商品除外）</p>
            <p>如需退回商品，您需在签收商品之日起7日内，对支持7天无理由退货且符合完好标准的商品, 可向我们发起7天无理由退货申请。</p>
            <p>请您于上述期限内联系Onitsuka Tiger官方线上商城在线客服，并根据退货政策、页面提示或客服提示提供所需信息完成退货申请。</p>
            <p>如果商品符合退货政策的要求和期限，我们将于收到退回商品之日起7日内为您更换或向您返还支付的商品价款。本退货政策仅适用于中国大陆地区（不包括中国香港，中国澳门和中国台湾地区）的消费者。</p>
            <p>*对于商品完好的标准，请仔细阅读以下特别注意事项的内容。</p>
            <p><span></span></p>
            <h3>三包期内质量问题退货</h3>
            <p><span></span></p>
            <p>商品支持三包期内因质量问题的退货（国家三包范围认定的质量问题）</p>
            <p>商品购买后如有瑕疵（非质量问题），应于商品签收之日起7天内联系Onitsuka Tiger官方线上商城在线客服进行申请退货。</p>
            <p>存在我司判定后属于质量问题的订单，我们将免费为您办理无忧退货。但需要您注意的是，非质量问题退货产生的运费，还需您本人进行承担。</p>
            <p>商品若经修改或使用不当，都不适用于更换及退货条款。</p>
            <p><span></span></p>
            <h3>特别注意事项：</h3>
            <p><span></span></p>
            <h4>1.关于商品</h4>
            <p><span></span></p>
            <p>请将原始购物凭据及原始发票、赠品、装箱清单、以及销售小票与货物一起退回。</p>
            <p>7天无理由退货商品须保证不影响二次销售：请确保商品完好（吊牌未减、未使用、未洗涤）、鞋盒/包装完整、填充物完好、鞋底/衣物保持干净整洁、无穿着痕迹，请您将所有包装、配件、相关文件和赠品，连同原始购物凭证和发票一并退回。</p>
            <p>商品购买后如有质量瑕疵，应于收到商品之日起七日内申请退货，如有质量问题，请与线上商城在线客服沟通确认后，在三包期内申请退货。</p>
            <p>请恕我们不接受非本官方线上商城发出的商品、无购买记录的商品和不符合本商城退货规则的商品，对于恶意退货者，公司保留追究的权利。</p>
            <p>请您理解，非因质量问题的定制款商品可能不适用无理由退货政策。</p>
            <p><span></span></p>
            <h4>2.关于包装</h4>
            <p><span></span></p>
            <p>请您理解我们商品包装、商品和吊牌的唯一性，如有鞋盒破损、涂画、缠绕胶带、吊牌缺失等影响二次销售的情况，将不支持退货。您所退货的商品直接用货品鞋盒/服装包装袋当物流货运外包装寄回的，我们将一律拒收，并不予办理退货申请。（请不要用商品的包装直接寄回，外面请加快递纸盒包装）。</p>
            <h4>3.关于快递和运费</h4>
            <p>所退回的商品请使用快递送货上门服务，需收件方上门取货的物流方式一律拒收并不予办理退货申请（建议您使用Onitsuka Tiger推荐的快递退回商品）。</p>
            <p>所有我司判定为质量问题的退货我们会为您承担运费，您可以联系Onitsuka Tiger推荐的快递发货，并将邮费支付的截图发送给Onitsuka Tiger官方商城在线客服，我们将通过支付宝与您结算。</p>
            <p>如您是因为非质量问题退货，您需承担商品退回的运费。</p>
            <p>申请退货时，请您仔细阅读退货政策和特别注意事项，任何与相关法律规定及本政策不符的情况，均可能导致您退货失败。</p>
            <h4>4.关于质量问题退货流程</h4>
            <p>遇到质量问题时，请及时联系商城在线客服，问题点确认后，询问Onitsuka Tiger推荐的快递寄回。退货商品寄出后，请将物流信息填写到线上网站对应的订单中，请务必填写正确的物流信息。</p>
            <p>您收到的快递包裹里面是有一个发货清单，烦请您一并寄回，针对商品有任何建议和商品问题也可以在发货清单上表明，仓库收到后可以及时给您核对处理。</p>
            <h4>5.关于退款</h4>
            <p>对使用微信支付、支付宝支付或者花呗分期支付的在线订单，退款成功后，会直接原路退回您使用支付的对应账户中。退款仅支持中国大陆地区（不包括中国香港，中国澳门和中国台湾地区）。</p>
            <h4>6.以下商品不予退货：</h4>
            <p>随商品附赠的赠品。</p>
            <p>未按照商品使用或保养注意事项造成的商品受损、褪色、脱线、开裂等原因。</p>
            <p>未按照商品规定的用途，因不当使用商品造成的任何损失。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      siderList: [
        { name: "订单状态查询" },
        { name: "支持的付款方式" },
        { name: "配送方式和费用" },
        { name: "退换货政策" }
      ],
      activeItem: 0,
      title: "订单状态查询"
    };
  },
  created() {},
  watch: {
    $route(from) {
      this.clickSidebar(from.query.active);
    }
  },
  methods: {
    clickSidebar(idx) {
      this.activeItem = idx;
      switch (idx) {
        case 1:
          this.title = "支持的付款方式";
          break;
        case 2:
          this.title = "配送方式和费用";
          break;
        case 3:
          this.title = "退换货政策";
          break;
        default:
          this.title = "订单状态查询";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.privacy-policy {
  width: 110rem;
  margin: 0 auto;
  .title {
    text-align: center;
    padding-top: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
    h1 {
      font-size: 24px;
      font-weight: 400;
      text-transform: uppercase;
      letter-spacing: 0.1rem;
    }
  }
  .support-main {
    padding-top: 50px;
    .sidebar-column, .content-column { box-sizing: border-box; }
    .sidebar-column {
      width: 33%;
      padding-right: 15px;
      li {
        font-size: 1.4rem;
        font-weight: 400;
        text-transform: uppercase;
        list-style: none;
        border-bottom: 1px solid #999;
        padding: 0 0 15px;
        margin: 0 0 20px;
        text-align: left;
        span { color: #999; cursor: pointer; }
        &.current span { color: #000; }
      }
    }
    .content-column {
      width: 66%;
      padding-left: 15px;
      text-align: left;
      h2 { font-size: 3.2rem; }
      h3 { font-size: 2.4rem; }
      h4 { font-size: 1.8rem; }
      .article-typography {
        font-size: 1.2rem;
        -webkit-font-smoothing: antialiased !important;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);
        text-rendering: optimizeLegibility;
        font-weight: 200;
        padding-bottom: 50px;
        line-height: 2;
        p { color: #333; margin-bottom: 20px; word-wrap: break-word; }
        table, td {
            border: 1px solid #000; border-collapse: collapse;
        }
        table { width: 100%; }
        th, td { width: 25%; line-height: 40px; background: #FFF; }
        td em { color: #B4B5B4; }
      }
      .article-typography * { max-width: 110rem; margin: 0 auto; }
    }
  }
  .fl { float: left; }
  .fr { float: right; }
}
@media only screen and (max-width: 1024px) {
  .privacy-policy {
    width: auto;
    .support-main {
      .sidebar-column { padding: 0 15px; width: 100%; }
      .content-column { width: 100%; padding: 0 15px; }
    }
    .fl { float: none; }
    .fr { float: none; }
  }
}
</style>